import { render, staticRenderFns } from "./ProspectLost.vue?vue&type=template&id=2eb228b4&scoped=true"
import script from "./ProspectLost.vue?vue&type=script&lang=js"
export * from "./ProspectLost.vue?vue&type=script&lang=js"
import style0 from "./ProspectLost.vue?vue&type=style&index=0&id=2eb228b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb228b4",
  null
  
)

export default component.exports